import { render, staticRenderFns } from "./AddNivel1.vue?vue&type=template&id=6e2d7460&"
import script from "./AddNivel1.vue?vue&type=script&lang=js&"
export * from "./AddNivel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports